import RequestHandler from "./RequestHandler";

function ProductVersionCommentsAPI() {
    const baseProductVersionCommentsAPI = "product-version-comments";

    async function listComments(
        productVersionId,
        itemsPerPage,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "DESC";
            let URL = `${baseProductVersionCommentsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = RequestHandler.post(URL, { productVersionId });
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getComment(commentId) {
        try {
            const result = RequestHandler.get(
                `${baseProductVersionCommentsAPI}/${commentId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteComment(commentId) {
        try {
            const result = RequestHandler.remove(
                `${baseProductVersionCommentsAPI}/${commentId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function postComment(comment) {
        try {
            const result = RequestHandler.post(
                `${baseProductVersionCommentsAPI}`,
                comment
            );
            return result || false;
        } catch (error) {
            console.log(error);
        }
    }

    async function updateComment(comment) {
        try {
            const result = RequestHandler.put(
                `${baseProductVersionCommentsAPI}`,
                comment
            );
            return result || false;
        } catch (error) {
            console.log(error);
        }
    }

    return {
        listComments,
        getComment,
        deleteComment,
        postComment,
        updateComment,
    };
}

export default ProductVersionCommentsAPI();
